import React from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { getShiftsTimePerDay } from "../../../services/userModel";
import { useSelector } from 'react-redux';

const ShiftsSummary = ({ t, items }) => {
  const {sectionModels, currentModelType} = useSelector(state => state.sectionModel);
  const filterModel = sectionModels?.[currentModelType]?.model?.filterOptions;

  return (
    <div className={classNames("shiftsSummary")}>
      {items &&
        !!items.length && (
          <div className={classNames("total")}>
            <div className={classNames('title')}>{t("shifts.HOURS_PER_DAY_FOOTER_LABEL")}</div>
            <div className={classNames('total-time')}>{getShiftsTimePerDay(items, filterModel)}</div>
          </div>
        )}
    </div>
  )
}

export default withTranslation()(ShiftsSummary);
